import React from "react"
import Index from "../Index"
import { contentLayout, modules } from "../../config/pages"
import { useUser } from "../../contexts/UserContext"
import Forbidden from "../Forbidden"

function ViewChats (){
  const {user} = useUser()
  let view = contentLayout[modules.ChatList]
  if(user.permissions.views.length && !user.permissions.views.join().includes(modules.ChatList.toLowerCase())){
    view = Forbidden
  }
  return(
  <Index content={view} module={modules.ChatList}></Index>
 )
}

export default ViewChats
